import React, { useContext } from "react";
import firebase from "firebase";
import { parse } from "query-string";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import Page from "../components/Page";
import { useUser } from "../contexts/user";
import { FirebaseContext } from "../contexts/filrebase";
import { ReactComponent as Logo } from "../logo.svg";
import "firebaseui/dist/firebaseui.css";
import "./Auth.css";
import Header from "../components/Header";

const uiConfig = {
  // Popup signin flow rather than redirect flow.
  signInFlow: "popup",
  // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
  // signInSuccessUrl: "/signedIn",
  // We will display Google and Facebook as auth providers.
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.EmailAuthProvider.PROVIDER_ID,
  ],
};

function SignInScreen({ onSuccess = () => {}, firebaseAuth }) {
  const config = {
    ...uiConfig,
    callbacks: {
      signInSuccess: onSuccess,
      signInFailure: () => {},
    },
  };

  return (
    <Page className="AuthView">
      <div className="AuthView--logo" alt="Draw On logo">
        <Logo className="AuthView--logo--svg" />
      </div>
      <Header size="h2" className="AuthView--logo-text">
        Draw On
      </Header>
      <StyledFirebaseAuth uiConfig={config} firebaseAuth={firebaseAuth} />
    </Page>
  );
}

export const SignIn = ({ history: { location, replace } }) => {
  const firebase = useContext(FirebaseContext);
  const { user } = useUser();
  const params = parse(location.search);

  const onSuccess = () => {
    replace(params.r || "/");
  };

  if (user) {
    onSuccess();
  }
  return <SignInScreen firebaseAuth={firebase.auth()} onSuccess={onSuccess} />;
};

export default (props) => <SignIn {...props} onSuccess={() => {}} />;
